import { render, staticRenderFns } from "./PhotoDocumentation.vue?vue&type=template&id=7fe6f979&scoped=true"
import script from "./PhotoDocumentation.vue?vue&type=script&lang=js"
export * from "./PhotoDocumentation.vue?vue&type=script&lang=js"
import style0 from "./PhotoDocumentation.vue?vue&type=style&index=0&id=7fe6f979&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe6f979",
  null
  
)

export default component.exports